import { getObjectLink } from '@wf-mfe/navigation'

export default function parseLink(ID, objCode) {
  return `${getObjectLink({ ID, objCode }).to}/updates`
}
